import { useEffect, useState } from "react"
import { useTheme } from "@mui/material/styles"
import { Table as FormigaTable } from '@gisce/react-formiga-table'
import useTable from "./useTable"

const DEFAULT_SORTER = {
  id: "created_date",
  desc: true,
};

const Table = ({data, columns, loaded, onRowStatus}) => {
  const theme = useTheme();
  const { rows } = useTable({loaded, columns, data});
  const [sorter, setSorter] = useState(DEFAULT_SORTER);
  const [sortedRows, setSortedRows] = useState(rows ?? []);
  const hasRows = (sortedRows ?? []).length > 0;

  useEffect(() => {
    if (!sorter) {
      setSortedRows(rows ?? []);
      return;
    }

    const column = columns.find((currentColumn) => currentColumn.key === sorter.id);
    if (!column?.sorter) {
      setSortedRows(rows ?? []);
      return;
    }

    setSortedRows([...(rows ?? [])].sort((leftRow, rightRow) => (
      column.sorter(leftRow, rightRow, sorter.id, sorter.desc)
    )));
  }, [columns, rows, sorter]);

  return (
    <FormigaTable
      columns={columns}
      dataSource={sortedRows ?? []}
      loading={!loaded && !hasRows}
      onRowStatus={onRowStatus}
      onRowStyle={theme.custom?.components?.reactFormigaTable?.onRowStyle || (() => ({}))}
      loadingComponent={null}
      readonly={true}
      sorter={sorter}
      onChangeSort={setSorter}
    />
  )
}

export default Table;
